import { render } from "./Investors.vue?vue&type=template&id=77bc6e44"
import script from "./Investors.vue?vue&type=script&lang=js"
export * from "./Investors.vue?vue&type=script&lang=js"
script.render = render

export default script